import script from "./FormulaBuilder.vue?vue&type=script&setup=true&lang=js"
export * from "./FormulaBuilder.vue?vue&type=script&setup=true&lang=js"

import "./FormulaBuilder.vue?vue&type=style&index=0&id=1149de28&lang=css"

const __exports__ = script;

export default __exports__